
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { Prices } from '@core/components/prices'

import productThumbTranslations from '../ProductThumb.translations'
import { isLinkValid } from '../helpers'

import translations from './Card.translations'

/** @deprecated */
export default {
  components: {
    RevTag,
    RevIllustration,
    Prices,
    RevButtonBase,
    RevCard,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    titleModel: {
      type: String,
      default: '',
    },
    subTitleModel: {
      type: Array,
      default: () => [],
    },
    thumbnail: {
      type: String,
      required: true,
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} price
     * @property {number} price.raw
     * @property {string} price.display
     */
    price: {
      type: Object,
      required: true,
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} originalPrice.raw
     * @property {string} originalPrice.display
     */
    originalPrice: {
      type: Object,
      required: true,
    },
    warranty: {
      type: [String, Number],
      required: true,
    },
    grade: {
      type: String,
      default: '',
    },
    isRecommendation: {
      type: Boolean,
      default: false,
    },
    isOriginalPriceDisplayed: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    originalPriceDisplay() {
      return this.$t(productThumbTranslations.originalPriceDisplay, {
        price: this.originalPrice.display,
      })
    },
    translations: () => translations,
    productThumbTranslations: () => productThumbTranslations,
    displayRecoTag() {
      return this.isRecommendation
    },
    displayTitle() {
      return !this.displaySmartphoneDetails
    },
    displaySmartphoneDetails() {
      return !isEmpty(this.subTitleModel)
    },
    subTitleModelString() {
      return this.subTitleModel && this.subTitleModel.join(' - ')
    },
    displayWarranty() {
      return this.warranty
    },
    gradeFormatted() {
      return this.$t(translations.productThumbCondition, { grade: this.grade })
    },
    originalPriceValue() {
      return this.isOriginalPriceDisplayed ? this.originalPrice : undefined
    },
    shouldDisplayCard() {
      return isLinkValid(this.link, this.$navigation)
    },
  },
}
